import styled from "styled-components";

export const NavbarStyled = styled.div`
  padding: 30px 0;
  position: relative;

  nav {
    width: 100%;
  }
  ul {
    list-style: none;
    display: flex;
    width: 100%;
    padding: 0;
  }
  li {
    width: 100%;
    padding: 0 1rem;
    width: 100%;
    border-right: 2px solid rgb(175, 175, 175);
  }
  li:nth-of-type(1) {
    padding-left: 0;
  }
  li:nth-last-child(1) {
    border-right: none;
  }
  i {
    position: relative;
    font-size: 1.5rem;
  }
  svg {
    position: absolute;
    transform: translate(-50%, -50%);
  }
  a.white {
    color: white;
  }
  a.black {
    color: black;
  }
  .nav-icon {
    position: absolute;
    top: 30px;
    right: 30px;
    display: none;
  }
  .fa-times {
    margin-right: 1.5rem;
  }

  @media only screen and (max-width: 768px) {
    position: fixed;
    width: 85%;
    top: 0;

    .nav-icon {
      display: inline;
    }
    ul {
      display: none;
      flex-direction: column;
    }
    .active {
      display: inline;
    }
    .active li {
      padding-top: 4rem;
      padding-left: 1.3rem;
      font-size: 1rem;
    }
    li {
      padding: 0;
      border-right: none;
    }
  }
`;
